import { useState } from 'react';
import { useModal } from '../../Modal/hooks/useModal';
export var usePresetState = function () {
    var _a = useModal(), isPresetsModalOpen = _a.isOpen, onOpenPresetsModal = _a.onOpen, onClosePresetsModal = _a.onClose;
    var _b = useState(''), selectedPresetName = _b[0], setSelectedPresetName = _b[1];
    return {
        isPresetsModalOpen: isPresetsModalOpen,
        onOpenPresetsModal: onOpenPresetsModal,
        onClosePresetsModal: onClosePresetsModal,
        selectedPresetName: selectedPresetName,
        setSelectedPresetName: setSelectedPresetName
    };
};
